import FormInputExpiry from '../form-input-expiry';
import FormInputPhone from '../form-input-phone';
import FormInputText from '../form-input-text';
import Pictogram from '../pictogram';
import React, { useEffect, useState } from 'react';
import TranslatedCopy from '../../../intl/translated-copy';
import cardRegex from '../../../constants/card-regex';
import cx from 'classnames';
import formInputDropdown from '../form-input-dropdown';
import paymentPenaltyChargeValidation from '../../../validation/payment-penalty-charge';
import regexMap from '../../../constants/regex-map';
import { Field, Form, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { cvc } from '../../../validation/validation';
import { getCountryCodeIndex } from '../../../intl/utils';

const mapStateToProps = state => ({
  countryContent: state.Countries.countryContent,
  storefront: state.Manage.storefront,
  newPenaltyCardForm: state.form['newPenaltyCardForm'],
});

let ModalAddNewCard = ({
  addNewCardToCardList,
  countryContent,
  newPenaltyCardForm,
  setOpenModalAddNewCard,
  storefront,
}) => {
  const [disableButton, setDisableButton] = useState(true);
  const [inputCardIcon, setInputCardIcon] = useState(null);

  const inputCardIconClass = cx({
    'ModalAddNewCard-modal-form-cardInfo--cardLogo': true,
    'mastercard': inputCardIcon === 'Mastercard',
    'visa': inputCardIcon === 'VisaLogo',
    'amex': inputCardIcon === 'Amex',
  });

  useEffect(() => {
    if (newPenaltyCardForm !== undefined && (newPenaltyCardForm?.syncErrors === null || newPenaltyCardForm?.syncErrors === undefined)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }

    if (!newPenaltyCardForm?.syncErrors?.cardNumber) {
      const isMasterCard = cardRegex.MASTER.test(newPenaltyCardForm?.values?.cardNumber);
      const isVisa = cardRegex.VISA.test(newPenaltyCardForm?.values?.cardNumber);
      const isAmex = cardRegex.AMEX.test(newPenaltyCardForm?.values?.cardNumber);

      let cardType = '';
      if (isMasterCard) {
        cardType = 'Mastercard';
      } else if (isVisa) {
        cardType = 'VisaLogo';
      } else if (isAmex) {
        cardType = 'Amex';
      }

      setInputCardIcon(cardType);
    } else {
      setInputCardIcon(null);
    }
  }, [newPenaltyCardForm]);

  const getCountryOBjOptions = () => {
    return countryContent.map(country => {
      return {
        name: country?.name,
        value: country?.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isMasterCard = cardRegex.MASTER.test(newPenaltyCardForm?.values?.cardNumber);
    const isVisa = cardRegex.VISA.test(newPenaltyCardForm?.values?.cardNumber);
    const isAmex = cardRegex.AMEX.test(newPenaltyCardForm?.values?.cardNumber);
    let cardType = '';
    if (isMasterCard) {
      cardType = 'Mastercard';
    } else if (isVisa) {
      cardType = 'VisaLogo';
    } else if (isAmex) {
      cardType = 'Amex';
    }

    const newCard = {
      expiryMonth: newPenaltyCardForm?.values?.expirationDate.split('-')?.[1],
      expiryYear: newPenaltyCardForm?.values?.expirationDate.split('-')?.[0].slice(-2),
      lastDigits: newPenaltyCardForm?.values?.cardNumber.slice(-4),
      cardType: cardType,
    };
    addNewCardToCardList(newCard);
    setOpenModalAddNewCard(false);
  };

  const countryList = getCountryOBjOptions();
  let countryCodeIndex = null;
  const defaultValue = storefront ? storefront.split('-')[1] : 'MX';

  if (countryContent && countryContent.length) {
    countryCodeIndex = getCountryCodeIndex(defaultValue, countryContent);
  }

  return (
    <div className='ModalAddNewCard'>
      <div className='ModalAddNewCard-modal'>
        <div className='ModalAddNewCard-modal-titleSection'>
          <TranslatedCopy
            className='ModalAddNewCard-modal-titleSection-title'
            copyID='R&P_AEROWALLET_PAYMENT_AERO_CREDIT_OR_DEBIT_CARD'
            tagName='p'
          />
          <div
            onClick={ () => setOpenModalAddNewCard(false) }
          >
            <Pictogram
              className='ModalAddNewCard-modal-titleSection-icon'
              id='Close'
            />
          </div>
        </div>
        <Form
          className='ModalAddNewCard-modal-form'
          onSubmit={ (e) => handleSubmit(e) }
        >
          <div className='ModalAddNewCard-modal-form-cardInfo'>
            <Field
              autocompleteName='cc-number'
              className='ModalAddNewCard-modal-form-field'
              component={ FormInputText }
              isRequired={ true }
              labelCopyID='REVIEW_CARD_NUMBER'
              name='cardNumber'
            />
            { inputCardIcon &&
              <Pictogram id={ inputCardIcon } className={ inputCardIconClass } />
            }
          </div>
          <Field
            className='ModalAddNewCard-modal-form-field'
            component={ FormInputText }
            isRequired={ true }
            labelCopyID='REVIEW_NAME_ON_CARD'
            name='nameOnCard'
            normalize={ value => (value === ' ') ? '' : value }
          />
          <div className='ModalAddNewCard-modal-form-row'>
            <Field
              component={ FormInputExpiry }
              isRequired={ true }
              labelCopyID='USER_PROFILE_EXPIRATION'
              name='expirationDate'
            />
            <Field
              autocompleteName='cc-csc'
              className='ModalAddNewCard-modal-form-field'
              component={ FormInputText }
              isRequired={ true }
              labelCopyID='REVIEW_CVC'
              maxLength={ 4 }
              name='cvc'
              normalize={ value => value.replace(regexMap.SPACES_ONLY, '') }
              validate={ cvc }
            />
          </div>
          <TranslatedCopy
            className='ModalAddNewCard-modal-form-subtitle'
            copyID='REVIEW_BILLING_INFORMATION'
          />
          <label className='ModalAddNewCard-modal-form-labelContainer'>
            <TranslatedCopy
              copyID='MYB_USE_ADDRESS_SAVED_IN_ACCOUNT'
              tagName='span'
            />
            <input type='checkbox' />
            <span className='ModalAddNewCard-modal-form-checkmark' />
          </label>
          <div className='ModalAddNewCard-modal-form-row'>
            <Field
              autocompleteName='country'
              className='ModalAddNewCard-modal-form-field'
              component={ formInputDropdown }
              defaultOption={ countryCodeIndex }
              isRequired={ true }
              labelCopyID='REVIEW_COUNTRY'
              name='addressCountry'
              options={ countryList }
              value={ defaultValue }
            />
            <Field
              autocompleteName='address-level2'
              className='ModalAddNewCard-modal-form-field'
              component={ FormInputText }
              isRequired={ true }
              labelCopyID='REVIEW_CITY'
              name='addressCity'
            />
          </div>
          <Field
            className='ModalAddNewCard-modal-form-field'
            component={ FormInputText }
            isRequired={ true }
            labelCopyID='REVIEW_STREET_ADDRESS'
            name='addressStreet'
          />
          <Field
            className='ModalAddNewCard-modal-form-field'
            component={ FormInputText }
            isRequired={ true }
            labelCopyID='REVIEW_STATE_PROVINCE'
            name='addressStateIntl'
            showOptionalLabel={ true }
          />
          <div className='ModalAddNewCard-modal-form-row'>
            <Field
              className='ModalAddNewCard-modal-form-field isOptional'
              component={ FormInputText }
              isRequired={ false }
              labelCopyID='REVIEW_APT_UNIT'
              name='addressApartment'
            />
            <Field
              className='ModalAddNewCard-modal-form-field'
              component={ FormInputText }
              isRequired={ true }
              labelCopyID='REVIEW_ZIP_POSTAL'
              name='addressZip'
            />
          </div>
          <Field
            autocomplete={ false }
            className='ModalAddNewCard-modal-form-field isRequired phone-label'
            component={ FormInputPhone }
            countryContent={ countryContent }
            isRequired={ true }
            labelCopyID={ 'REVIEW_PHONE_NUMBER' }
            name='billingPhone'
          />
          <Field
            className='ModalAddNewCard-modal-form-field'
            component={ FormInputText }
            isRequired={ true }
            labelCopyID='APP_EMAIL'
            name='billingEmail'
          />
          <label className='ModalAddNewCard-modal-form-labelContainer'>
            <TranslatedCopy
              copyID='MYB_SAVE_CARD_FOR_FUTURE_PURCHASES'
              tagName='span'
            />
            <input type='checkbox' />
            <span className='ModalAddNewCard-modal-form-checkmark' />
          </label>
          <button
            className='ModalAddNewCard-modal-form-button'
            disabled={ disableButton }
          >
            <TranslatedCopy copyID='CONTINUE' />
          </button>
        </Form>
      </div>
    </div>
  );
};

ModalAddNewCard = reduxForm({
  form: 'newPenaltyCardForm',
  validate: paymentPenaltyChargeValidation,
})(ModalAddNewCard);

export default connect(mapStateToProps)(ModalAddNewCard);
